<template>
  <v-container fluid ref="AllReport" id="printMe">
    <v-row justify="center">
      <v-col cols="12" class="d-flex d-md-none justify-center">
        <cashDisplay
          colorName="black"
          :isloading="isloading"
          :Balance="OldBlc"
        ></cashDisplay>
      </v-col>
      <v-col cols="12" class="d-flex d-md-none">
        <cashDisplay
          colorName="blue-grey "
          :isloading="isloading"
          :Balance="AvailbeBlc"
        ></cashDisplay>
      </v-col>
      <v-col cols="12" class="d-none d-md-flex">
        <v-toolbar color="grey lighten-4">
          <v-toolbar-items>
            <cashDisplay
              colorName="black"
              :isloading="isloading"
              :Balance="OldBlc"
            ></cashDisplay>
          </v-toolbar-items>

          <v-spacer></v-spacer>
          <v-toolbar-items>
            <cashDisplay
              colorName="blue-grey "
              :isloading="isloading"
              :Balance="AvailbeBlc"
            ></cashDisplay>
          </v-toolbar-items>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <div>
              <cashDisplay2
                :isloading="isloading"
                :Balance="ToDayBlc"
              ></cashDisplay2>
            </div>

            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              class="d-print-none"
              append-icon="mdi-search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-btn
              v-if="Transactions.length"
              icon
              class="d-print-none"
              @click="PrintPage"
              small
              color="success"
            >
              <v-icon>mdi-printer-settings</v-icon>
            </v-btn>
          </v-card-title>

          <v-data-table
            :mobile-breakpoint="NaN"
            :headers="headers"
            :items="Transactions"
            :search="search"
            :loading="searching"
            :items-per-page="itemPerPage"
          >
            <!-- <template v-slot:item.Ref="{ item }">
              <template>
                <v-btn class="d-print-none" text color="success">{{
                  item.Ref
                }}</v-btn>
              </template>
            </template> -->
            <template v-slot:item.deposit="{ item }">
              <template v-if="item.Acc == 'Dr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </template>
            </template>
            <template v-slot:item.withdraw="{ item }">
              <template v-if="item.Acc == 'Cr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </template>
            </template>
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>
                <div class="flex-grow-1"></div>
                <v-dialog v-model="dialog" max-width="500px" persistent>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2 d-print-none"
                      v-on="on"
                      >Search Account</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Search Account</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-form ref="form" class="mx-5">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model="fromDate"
                                :rules="[v => !!v || 'From Date is required']"
                                required
                                name="FromDate"
                                label="From Date"
                                type="date"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model="toDate"
                                :rules="[v => !!v || 'To Date is required']"
                                required
                                name="ToDate"
                                label="To Date"
                                type="date"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                        color="blue darken-1"
                        :disabled="searching"
                        text
                        @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        :loading="searching"
                        text
                        @click="OnSearch"
                        >Search</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
          </v-data-table>
          <v-card-actions class="d-flex flex-column flex-md-row justify-end ">
            <InOut
              :key="index"
              v-for="(cash, index) in InOUtBlc"
              :Total="cash"
            ></InOut>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from "axios";
import cashDisplay2 from "@/components/displayCashTwo.vue";
import cashDisplay from "@/components/displayCash.vue";
import InOut from "@/components/util/InOut.vue";
import { EventBus } from "../main";

export default {
  components: { cashDisplay, cashDisplay2, InOut },
  data() {
    return {
      itemPerPage: 10,
      isloading: false,
      searching: false,
      search: "",
      fromDate: "",
      toDate: "",
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Client", value: "FullName" },
        { text: "Details", value: "Details" },
        { text: "Cash Type", value: "AmountType" },
        { text: "Deposit", value: "deposit" },
        {
          text: "Withdrawal",
          value: "withdraw",
          class: "blue--text",
        },
        { text: "User", value: "User" },
        // { text: "Ref", value: "Ref", class: "d-print-none" }
      ],
      Transactions: [],
      OldBlc: [],
      AvailbeBlc: [],
      ToDayBlc: [],
      dialog: false,
    };
  },
  watch: {},
  computed: {
    InOUtBlc() {
      if (!this.Transactions.length) return [];

      let total = this.Transactions.reduce((result, item) => {
        let Current = result[item.AmountType] || { Cr: 0, Dr: 0 };

        result[item.AmountType] = {
          ...(result[item.AmountType] || Current),
          [item.Acc]: Current[item.Acc] + Math.abs(item.Amount),
          Cash: item.AmountType,
        };
        return result;
      }, {});
      return total;
      //   return Object.keys(total).map(key => total[key]);
    },
  },
  methods: {
    async PrintPage() {
      this.itemPerPage = this.Transactions.length;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      this.itemPerPage = 10;
    },
    OldBalane(to) {
      return this.$store.dispatch("INSERT_ONLY", {
        url: "/Reports/Banktotalcash",
        data: {
          Account: "Main Cash",
          from: null,
          to,
        },
      });
    },
    TodayBalance(from, to) {
      return this.$store.dispatch("INSERT_ONLY", {
        url: "/Reports/DainlyInOut",
        data: {
          Account: "Main Cash",
          from,
          to,
        },
      });
    },
    AvailibleBalance(to) {
      // console.log(to);

      // console.log(this.Current(to).tomorrow);
      return this.$store.dispatch("INSERT_ONLY", {
        url: `/Reports/Banktotalcash`,
        data: {
          Account: "Main Cash",
          from: null,
          to: this.Current(to).tomorrow,
        },
      });
    },
    TranSactionsRep(from, to) {
      return this.$store.dispatch("INSERT_ONLY", {
        url: "/Reports/BankReport",
        data: {
          from,
          to,
        },
      });
    },

    AllReq(from, to) {
      return axios.all([
        this.OldBalane(from),
        this.AvailibleBalance(to),
        this.TranSactionsRep(from, to),
        // this.TodayBalance(from, to),
      ]);
    },

    close() {
      this.dialog = false;
    },
    OnSearch() {
      if (this.$refs.form.validate()) {
        this.Transactions = [];
        this.OldBlc = [];
        this.AvailbeBlc = [];
        this.ToDayBlc = [];

        this.searching = true;
        this.isloading = true;
        this.$store;
        this.AllReq(this.fromDate, this.toDate)
          .then(result => {
            //   console.log(result);
            this.OldBlc = result[0].data;
            this.AvailbeBlc = result[1].data;
            this.Transactions = result[2].data;
            // this.ToDayBlc = result[3].data;
            this.searching = false;
            this.isloading = false;
            if (this.Transactions.length) this.close();
          })
          .catch(() => {
            // console.log(error);
            this.searching = false;
            this.isloading = false;
          });
      }
    },
  },
  mounted() {
    let date = this.Current().date;
    this.searching = true;
    this.isloading = true;
    this.fromDate = date;
    this.toDate = date;
    this.AllReq(date, date)
      .then(result => {
        // console.log(result);
        this.OldBlc = result[0].data;
        this.AvailbeBlc = result[1].data;
        this.Transactions = result[2].data;
        this.ToDayBlc = result[3].data;
        this.searching = false;
        this.isloading = false;
      })
      .catch(() => {
        // console.log(error);
        this.searching = false;
        this.isloading = false;
      });
  },
};
</script>
